module.exports = __webpack_public_path__ + "img/cc37763.jpg";